import axios from 'axios';
import {IAcceptInvitationRequestBody, IUser} from "./User.types";

export default class UserApi {
    static async getMe(token?: string) {
        let config = {}
        if (token){
            config['headers'] = {'Authorization': `Bearer ${token}`}
        }
        try {
            let res = await axios.get('/users/me', config)
            if (res) {
                return res.data as IUser;
            }
        } catch (e) {
            console.error('Could not fetch /users/me');
        }
    }

    static async deleteUser(userId:number){
        try {
            let res = await axios.delete(`/users/${userId}`);
            if (res) {
                return res.data as IUser;
            }
        } catch (e) {
            console.error('Could not delete user with id', userId);
        }
    }

    static async getUsers({ queryKey }) {
        //eslint-disable-next-line
        const [_key, rawParams, page] = queryKey;
        let _limit = 25;

        let params = {}
        Object.keys(rawParams).forEach(key => {
            params[`${key}_contains`] = rawParams[key];
        })
        params = {
            ...params,
            _start: (page - 1) * _limit,
            _limit,
        }

        try {
            let res = await axios.get('/users', { params });
            let resCount = await axios.get('/users/count', { params })
            if (res && resCount) {
                return {
                    records: res.data as IUser[],
                    totalRecords: resCount.data as number,
                }
            } else {
                return undefined;
            }
        } catch (e) {
            console.log('Error getting users', e.message);
            return undefined;
        }
    }

    static async getUserById(userId:number){
        try {
            let res = await axios.get(`/users/${userId}`);
            if (res) {
                return res.data as IUser
            }
        } catch (e) {
            console.log(`Error getting user with ID ${userId}`, e.message);
            return undefined;
        }
    }

    static async acceptInvitation(data:IAcceptInvitationRequestBody){
        try {
            let res = await axios.post(`/invite-user/accept-invitation`, data);
            if (res) {
                return res.data as IUser
            }
        } catch (e) {
            console.log(`Error accepting invitation`, e.message);
            return undefined;
        }
    }

    static async inviteAdmin(values: any) {
        try {
            let res = await axios.post('/invite-user/admin', values);
            if (res) {
                return res.data as IUser
            }
        } catch (e) {
            console.log('Error inviting admin', e.message);
            return undefined;
        }
    }

    static async inviteClient(values: any) {
        try {
            let res = await axios.post('/invite-user/client', values);
            if (res) {
                return res.data as IUser
            }
        } catch (e) {
            console.log('Error inviting client', e.message);
            return undefined;
        }
    }

    static async inviteSales(values: any) {
        try {
            let res = await axios.post('/invite-user/sales', values);
            if (res) {
                return res.data as IUser
            }
        } catch (e) {
            console.log('Error inviting sales', e.message);
            return undefined;
        }
    }

    static async updateUserRole(userId:number, role_name:string){
        try {
            let res = await axios.put(`/custom-user/update-user-role/${userId}`, {role_name});
            if (res) {
                return res.data as IUser
            }
        } catch (e) {
            console.log('Error updating user', e.message);
            return undefined;
        }
    }
}